<a [customRouterLink]="category.linkRef" class="category-item-container" *ngIf="category">
  <div class="category">
    <div class="image-container">
      <img
        *ngIf="category.image as image; else noImage"
        [lazyLoad]="image.url + '?width=200&height=200&&padColor=F9FAFA'"
        [defaultImage]="image.url + '?width=50&height=50&&padColor=F9FAFA'"
        errorImage="./assets/ui/shared/error/not_found_error_image.png"
        src="#"
        [alt]="image.altText"
        [title]="image.titleText"
      />
      <ng-template #noImage>
        <img
          lazyLoad="./assets/ui/shared/error/not_found_error_image.png"
          defaultImage="./assets/ui/shared/error/not_found_error_image.png"
          errorImage=".|assets/ui/shared/error/not_found_error_image.png"
          src="#"
          title="missing_image"
          alt="missing_image"
        />
      </ng-template>
    </div>
    <div class="name" *ngIf="category.linkRef as link; else noLink">{{ category.linkRef.linkName }}</div>
    <ng-template #noLink>
      <div class="name">unknown</div>
    </ng-template>
  </div>
</a>
